<template>
<v-container>
    
    <v-row class='justify-center'>
        <v-col lg=11 md=12>
            <h1>Settings</h1>
            <v-card min-height='300' class='pa-6 pt-1 mt-5'>
                <v-card-title class='pl-2'>
                    <v-row justify=space-between>
                        Store Details <v-btn @click="storeDetailsEdit=true" v-show="!storeDetailsEdit">Edit</v-btn>
                    </v-row>
                </v-card-title>
             <v-row justify='space-between'>
                <v-col lg=5>
                        Logo:
                    <v-img v-bind:src="logo" contain height=150 alt="logo_image" class='mb-5'></v-img>

                        Banner Image:
                    <v-img v-bind:src="banner" height='210' cover alt="banner_image" class='mb-5'></v-img>
                    </v-col>
                <v-col lg=5 justify='center'>
                 
                    <v-form id="form" ref="form" v-if='storeDetailsEdit'>
                        <v-text-field :rules="[rules.required]" outlined v-model="name" dense label='Name of your Store'></v-text-field>
                        <v-text-field :rules="[rules.required]" outlined v-model="type" dense label='Type of your Store'></v-text-field>

                        <v-text-field :rules="[rules.required]" outlined v-model="address1" dense label='Address line 1'></v-text-field>
                        <v-text-field outlined v-model="address2" dense label='Address Line 2'></v-text-field>
                        <v-text-field :rules="[rules.required]" outlined v-model="city" dense label='City'></v-text-field>
                        <v-text-field :rules="[rules.required]" outlined v-model="state" dense label='State'></v-text-field>
                        <v-text-field :rules="[rules.required]" outlined v-model="pincode" dense label='Pincode'></v-text-field>
                        
                        <v-btn class='mr-2' @click='storeDetailsEdit=false'>Cancel</v-btn>
                        <v-btn @click="saveStore" color='primary'>Save</v-btn>
                    </v-form>
                     <div v-else>
                           
                        <p>Name : <br><span>{{name}}</span></p>
                        <p>Type of Store :<br><span>{{type}}</span></p>
                        <p>Address: <br>{{address1}},
                        <br>{{address2}}
                        <br>{{city}},
                        <br>{{state}},
                        <br>{{pincode}},</p>
                    </div>
                </v-col>
                    </v-row>
             
                
            </v-card>
            <v-card class='pa-6 pt-1 mt-5'>
                 <v-card-title class='pl-2'>
                    <v-row justify=space-between>
                        Personal Details <v-btn>Edit</v-btn>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <p>Profile Picture:</p>
                    <v-avatar size=200 class='profile'>
                    <img
                
                        src="https://cdn.vuetifyjs.com/images/john.jpg"
                        alt="John"
                    >
                    </v-avatar>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>
<script>
/*global myBaseURL*/

import axios from 'axios';

export default {
    name:'Settings',
    data() {
        return {
            slug : this.$route.params.store_slug,
            storeDetailsEdit:false,
            name: '',
            type: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            pincode: '',
            logo: '',
            banner: '',
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            },
        }
    },
    created(){
        var that = this;
        axios.request({
            url: '/store/' + that.slug,
            method: 'GET',
            baseURL: myBaseURL,
            headers: {
                'Authorization': 'Bearer '+ window.localStorage.access_token
            }
        }).then(response => {
            console.log(response.data);
            that.name = response.data.name;
            that.type = response.data.category;
            that.address1 = response.data.address.line1;
            that.address2 = response.data.address.line2;
            that.city = response.data.address.city;
            that.state = response.data.address.state;
            that.pincode = response.data.address.pincode;
            that.logo = response.data.logo;
            that.banner = response.data.banner;
        }).catch(e => {
            console.log(e);
            console.log('Fail Data');
        });
    },
    methods: ({
        saveStore(){
            if(this.$refs.form.validate())
            {
                var that = this;
                var formData = new FormData();
                formData.append('name',that.name);
                formData.append('type',that.type);
                formData.append('address1',that.address1);
                formData.append('address2',that.address2);
                formData.append('city',that.city);
                formData.append('state',that.state);
                formData.append('pincode',that.pincode);
                
                axios.put( myBaseURL + '/store/' + that.slug,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer '+ window.localStorage.access_token
                        }
                    }
                ).then(response => {
                    console.log(response.data.store_slug);
                    this.storeDetailsEdit=false;
                    // this.$router.push({ name: 'ControlPanel', params : {store_slug : response.data.store_slug} })
                    console.log('Submit Success');
                }).catch(e => {
                    console.log(e);
                    console.log('Submit Fail');
                });
            }
        }
    })
}
</script>